import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AccountSubmitter from './AccountSubmitter';
import CreateAccount from './CreateAccount';
import { flags } from '../../data/loading.redux';

export const handleCreateAccountSubmit = ({ payload, client, redirect }) => {
  return async dispatch => {
    const submitter = new AccountSubmitter({ ...client, ...payload }, redirect, dispatch);
    submitter.clearErrorsAndSetLoading();

    if (!(await submitter.isEmailAddressAvailable())) return false;

    await submitter.createAccount();

    return true;
  };
};

const mapStateToProps = state => ({
  client: state.client,
  hasTopBanner: state.error?.errors?.length > 0,
  isLoading: state.loading[flags.EMAIL_AVAILABILITY] || state.loading[flags.ACCOUNT_CREATION],
});

const mapDispatchToProps = {
  handleCreateAccountSubmit,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateAccount));
